import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../../../App.css";
import Listdelete from "./ListDelete";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import Add from "./Add";

const baseURL = process.env.REACT_APP_API_JOBS;
function Documents(props) {
  const { visible, bhinameeting } = props;
  const [counter, setCounter] = useState(0);
  const [docOptions, setDocOptions] = useState();
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "bhinameetingdoctype/",
          {
            signal: controller.signal,
          }
        );
        isMounted && setDocOptions(response.data[0].docOptions);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    getData();
  }, []);

  const increment = () => {
    setCounter(counter + 1);
  };
  if (!visible || bhinameeting == null) return;
  return (
    <>
      <Add
        increment={increment}
        counter={counter}
        bhinameeting={bhinameeting}
        docOptions={docOptions}
      />
      <Listdelete
        increment={increment}
        counter={counter}
        setCounter={setCounter}
        bhinameeting_id={bhinameeting.id}
        docOptions={docOptions}
      />
    </>
  );
}

export default Documents;
